// extracted by mini-css-extract-plugin
export default {"activeSyncIcon":"ProviderIdDropdown_activeSyncIcon__hNY9X","inactiveSyncIcon":"ProviderIdDropdown_inactiveSyncIcon__-3V2w"};